<template>
	<div class="animated fadeIn">

		<b-row class="mb-3 align-items-center">
			<b-col>
				<h4 class="mb-0"><i class="fa fa-tags mr-2 text-primary"></i>Items</h4>
				<small class="text-muted">The Tipsoi Pay catalogue offered by the Create Client item picker</small>
			</b-col>
			<b-col class="text-right">
				<b-button variant="outline-secondary" size="sm" @click="load" :disabled="loading">
					<i class="icon-reload mr-1"></i>Refresh
				</b-button>
			</b-col>
		</b-row>

		<div v-if="loading" class="text-center py-5">
			<b-spinner variant="info" style="width:3rem;height:3rem;"></b-spinner>
		</div>

		<div v-else>
			<b-alert v-if="loadError" show variant="warning" class="small">{{ loadError }}</b-alert>

			<b-alert v-else-if="!items.length" show variant="light" class="border small text-muted">
				<i class="fa fa-info-circle mr-1 text-primary"></i>
				No items came back. Either Tipsoi Pay is not configured on this environment
				(<code>billing.api.url</code> / <code>billing.api.key</code>), or its catalogue is empty.
				Create Client's item picker will be empty for the same reason.
			</b-alert>

			<template v-else>
				<b-row class="mb-3">
					<b-col md="6" class="mb-2 mb-md-0">
						<b-input-group size="sm">
							<b-input-group-prepend is-text><i class="fa fa-search"></i></b-input-group-prepend>
							<b-form-input v-model="search" type="search" placeholder="Search item…"/>
						</b-input-group>
					</b-col>
					<b-col md="6" class="text-md-right">
						<small class="text-muted">{{ filtered.length }} of {{ items.length }} items</small>
					</b-col>
				</b-row>

				<b-card no-body>
					<div class="table-responsive">
						<table class="table table-sm table-striped table-hover mb-0">
							<thead>
								<tr>
									<th style="width:6rem">ID</th>
									<th>Item</th>
									<th class="text-right">Price</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in filtered" :key="item.id">
									<td><code>{{ item.id }}</code></td>
									<td>{{ itemName(item) }}</td>
									<td class="text-right num">{{ formatMoney(itemPrice(item)) }}</td>
								</tr>
								<tr v-if="!filtered.length">
									<td colspan="3" class="text-center text-muted py-4">No item matches that search.</td>
								</tr>
							</tbody>
						</table>
					</div>
				</b-card>
			</template>
		</div>
	</div>
</template>

<script>
import payService from '@/services/payService';

export default {
	name: 'PayItems',

	data() {
		return {
			loading: false,
			loadError: '',
			search: '',
			items: []
		};
	},

	computed: {
		filtered() {
			const term = this.search.trim().toLowerCase();
			if (!term) return this.items;
			return this.items.filter(item =>
				this.itemName(item).toLowerCase().indexOf(term) !== -1
				|| String(item.id || '').indexOf(term) !== -1);
		}
	},

	methods: {
		load() {
			this.loading = true;
			this.loadError = '';

			payService.getItems((items) => {
				this.loading = false;
				this.items = items || [];
			}, (err) => {
				this.loading = false;
				this.loadError = err;
			});
		},

		// The billing item payload is not under our control, so read the likely key names rather
		// than assuming one shape and rendering blanks if it changes.
		itemName(item) {
			return item.name || item.item_name || item.title || ('Item ' + (item.id || ''));
		},

		itemPrice(item) {
			const price = item.price !== undefined ? item.price
				: (item.selling_price !== undefined ? item.selling_price : item.item_price);
			return price === undefined || price === null ? null : price;
		},

		formatMoney(amount) {
			if (amount === null || amount === undefined) return '—';
			return '৳ ' + Number(amount).toLocaleString('en-IN');
		}
	},

	created() {
		this.load();
	}
};
</script>

<style scoped>
.num { font-variant-numeric: tabular-nums; }
</style>
